import NiceModal from "@ebay/nice-modal-react";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const ShowModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(95%, 1200px)", "80vh"];
  const withCloseButton = true;
  const modal = useRef();
  const clickOutsideToClose = true;
  const buttonText = t("close");
  const { title, children } = props;
  const [list, setList] = useState(props.list || []);
  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <VerticalFlex gap={10}>
        <FlexChild style>
          <div style={{ height: "68vh", overflow: "auto" }}>
            {children && children({ list: list, setList: setList })}
          </div>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex justifyContent="center" gap={10}>
            {props.onChange && (
              <FlexChild width="max-content">
                <AdminCustomButton
                  text="저장"
                  onClick={() => {
                    props.onChange({ list: list });
                    modal.current.close();
                  }}
                />
              </FlexChild>
            )}
            <FlexChild width="max-content">
              <AdminCustomButton
                text={props.onChange ? "취소" : "닫기"}
                onClick={() => modal.current.close()}
              />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
    </ModalBase>
  );
});
export default ShowModal;
